import { WORKFLOW_ACTIONS, NODE_DATA_BY_TYPE, NODE_TYPES } from 'modules/workflows/constants';

export const ACCOUNT_DROPDOWN_ID = 'account-id';
export const CUSTOM_AUDIENCE_ID = 'custom-audience-id';
export const EDITOR_TEST_ID = 'fb-audience-editor';

export const FB_ACTION_OPTIONS = [
  {
    id: 'Add user to...',
    value: WORKFLOW_ACTIONS.ADD_USER_TO_FB,
    name: 'Add user to...',
  },
  {
    id: 'Remove user from...',
    value: WORKFLOW_ACTIONS.REMOVE_USER_FROM_FB,
    name: 'Remove user from...',
  },
];

export const DEFAULT_FACEBOOK_CUSTOM_AUDIENCE_NODE_DATA =
  NODE_DATA_BY_TYPE[NODE_TYPES.ADD_USER_TO_FB];
